<template>
  <div class="print">
    <!-- 1. 헤더 및 결재란 -->
    <section class="page-break">
      <table>
        <colgroup>
          <col width="160" />
          <col width="220" />
          <col width="800" />
          <col width="100" />
          <col width="100" />
          <col width="100" />
          <col width="100" />
        </colgroup>
        <tr>
          <th class="gray">{{ $t("회사명") }}</th>
          <td>{{ form.stdInfo.field_name }}</td>
          <td rowspan="5">
            <span class="print-title"
              ><span style="color: #0029ff">[{{ $t("정기") }}]</span> {{ $t("위험성평가표") }}(3등급)</span
            >
          </td>
          <th colspan="4" class="gray">{{ $t("확인자") }}</th>
        </tr>
        <tr>
          <th class="gray">{{ $t("공정명") }}</th>
          <td>{{ form.stdInfo.공정명 }}</td>
          <th class="gray">{{ $t("작성자") }}</th>
          <th class="gray">{{ $t("검토자") }}</th>
          <th class="gray">{{ $t("회람자") }}</th>
          <th class="gray">{{ $t("승인자") }}</th>
        </tr>
        <tr>
          <th class="gray">{{ $t("작성자") }}</th>
          <td>{{ form.stdInfo.writer_name }}</td>
          <td rowspan="3" style="vertical-align: middle; height: 100px">
            <div class="signature-container">
              <img v-if="form.sign1.sign" :src="form.sign1.sign" class="signature-image" />
            </div>
          </td>
          <td rowspan="3" style="vertical-align: middle; height: 100px">
            <div class="signature-container">
              <img v-if="form.sign2.sign" :src="form.sign2.sign" class="signature-image" />
            </div>
          </td>
          <td rowspan="3" style="vertical-align: middle; height: 100px">
            <div class="signature-container">
              <img v-if="form.sign3.sign" :src="form.sign3.sign" class="signature-image" />
            </div>
          </td>
          <td rowspan="3" style="vertical-align: middle; height: 100px">
            <div class="signature-container">
              <img v-if="form.sign4.sign" :src="form.sign4.sign" class="signature-image" />
            </div>
          </td>
        </tr>
        <tr>
          <th class="gray">{{ $t("작성일") }}</th>
          <td>{{ form.stdInfo.date }}</td>
        </tr>
        <tr>
          <th class="gray">{{ $t("작업내용") }}</th>
          <td>{{ form.stdInfo.작업내용 }}</td>
        </tr>
      </table>

      <!-- 2. 위험성평가표 (riskList) -->
      <table class="mt-auto">
        <colgroup>
          <col style="min-width: 120px" />
          <col style="min-width: 120px" />
          <col style="width: 250px" />
          <col style="width: 120px" />
          <col style="width: 90px" />
          <col style="width: 50px" />
          <col style="width: 50px" />
          <col style="width: 50px" />
          <col style="width: 250px" />
          <col style="min-width: 130px" />
          <col style="width: 70px" />
          <col style="width: 70px" />
        </colgroup>
        <thead>
          <tr>
            <th colspan="12" class="text-left">❶ {{ $t("위험성평가표") }}</th>
          </tr>
          <tr>
            <th rowspan="3">{{ $t("①공종분류") }}</th>
            <th rowspan="3">{{ $t("②단위작업") }}</th>
            <th rowspan="3">{{ $t("③위험요인") }}</th>
            <th rowspan="3">{{ $t("재해형태") }}</th>
            <th colspan="4" class="text-center">{{ $t("④위험성 결정") }}</th>
            <th rowspan="3">{{ $t("⑤위험방지대책") }}</th>
            <th rowspan="3">{{ $t("⑥개선조치 담당자") }}<br />{{ $t("조치예정일") }}</th>
            <th rowspan="2" colspan="2">{{ $t("➉이행확인") }}</th>
          </tr>
          <tr>
            <th rowspan="2">{{ $t("산출근거") }}</th>
            <th colspan="3" class="text-center">{{ $t("위험도 등급") }}</th>
          </tr>
          <tr>
            <th>{{ $t("상") }}</th>
            <th>{{ $t("중") }}</th>
            <th>{{ $t("하") }}</th>
            <th>{{ $t("대표") }}</th>
            <th>{{ $t("감독") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="form.riskList.length === 0">
            <td colspan="12" class="text-left">{{ $t("작성된 내용이 없습니다.") }}</td>
          </tr>
          <template v-else>
            <tr v-for="(item, index) in form.riskList" :key="`risk_${index}`">
              <td>{{ item.input1 }}</td>
              <td>{{ item.input2 }}</td>
              <td class="text-left">{{ item.input3 }}</td>
              <td>{{ $t(`${item.input4}`.replaceAll("직접입력_", "").replaceAll("직접 입력_", "")) }}</td>
              <td>{{ scoreSummary(item) }}</td>
              <td><PrintRadio :value="item.input5 === '상'" class="justify-center" /></td>
              <td><PrintRadio :value="item.input5 === '중'" class="justify-center" /></td>
              <td><PrintRadio :value="item.input5 === '하'" class="justify-center" /></td>
              <td class="text-left">{{ item.input6 }}</td>
              <td>
                <div>{{ item.input7 }}</div>
                <div v-if="item.input8">{{ item.input8 }}</div>
              </td>
              <td><PrintCheckbox :value="item.input9" class="flex justify-center" /></td>
              <td><PrintCheckbox :value="item.input10" class="flex justify-center" /></td>
            </tr>
          </template>
        </tbody>
      </table>
    </section>

    <!-- 3. 관리자 목록 (managerList) -->
    <section class="page-break">
      <table>
        <thead>
          <tr>
            <th colspan="5" class="text-left">❷ {{ $t("➆ 위험성 결정, 감소대책 수립 및 실행계획 확인") }}</th>
          </tr>
          <tr>
            <th>{{ $t("소속명") }}</th>
            <th>{{ $t("직급") }}</th>
            <th>{{ $t("직책") }}</th>
            <th>{{ $t("이름") }}</th>
            <th>{{ $t("서명") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="form.managerList.length === 0">
            <td colspan="5" class="text-left">{{ $t("작성된 내용이 없습니다.") }}</td>
          </tr>
          <template v-else>
            <tr v-for="(item, index) in form.managerList" :key="`manager_${index}`">
              <td>{{ item.target }}</td>
              <td>{{ item.position }}</td>
              <td>{{ item.type }}</td>
              <td>{{ item.name }}</td>
              <td style="height: 60px; vertical-align: middle">
                <div class="signature-container" style="height: 50px">
                  <img v-if="item.sign" :src="item.sign" class="signature-image" style="max-height: 40px" />
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </section>

    <!-- 4. 개선현황 (photoListBeforeAfter) -->
    <section class="page-break">
      <table class="mt-auto">
        <colgroup>
          <col width="50" />
          <col />
          <col />
          <col width="50" />
          <col />
          <col />
        </colgroup>
        <thead>
          <tr>
            <th colspan="6" class="text-left">❸ {{ $t("개선현황") }}</th>
          </tr>
          <tr>
            <th>No.</th>
            <th>{{ $t("조치 전 사진") }}</th>
            <th>{{ $t("조치 후 사진") }}</th>
            <th>No.</th>
            <th>{{ $t("조치 전 사진") }}</th>
            <th>{{ $t("조치 후 사진") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="form.photoListBeforeAfter.length === 0">
            <td colspan="6" class="text-left">{{ $t("작성된 내용이 없습니다.") }}</td>
          </tr>
          <template v-else>
            <tr v-for="(row, rowIndex) in photoRows" :key="`photo_row_${rowIndex}`">
              <th>{{ row.idx1 }}</th>
              <td>
                <div class="photo-container">
                  <img v-if="row.photo1Path" :src="row.photo1Path" class="photo-image" />
                </div>
              </td>
              <td>
                <div class="photo-container">
                  <img v-if="row.photoAfter1Path" :src="row.photoAfter1Path" class="photo-image" />
                </div>
              </td>
              <template v-if="row.idx2 <= form.photoListBeforeAfter.length">
                <th>{{ row.idx2 }}</th>
                <td>
                  <div class="photo-container">
                    <img v-if="row.photo2Path" :src="row.photo2Path" class="photo-image" />
                  </div>
                </td>
                <td>
                  <div class="photo-container">
                    <img v-if="row.photoAfter2Path" :src="row.photoAfter2Path" class="photo-image" />
                  </div>
                </td>
              </template>
              <template v-else>
                <th></th>
                <td></td>
                <td></td>
              </template>
            </tr>
          </template>
        </tbody>
      </table>
    </section>
  </div>
</template>

<script>
import PrintRadio from "@/components/print/PrintRadio.vue";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";

export default {
  name: "Print",
  components: { PrintRadio, PrintCheckbox },
  props: {
    isPrint: Boolean,
    board: Object,
    form: Object,
  },
  computed: {
    photoRows() {
      const rows = [];
      const getPath = (img) => {
        return img && img.path ? img.path : null;
      };
      for (let i = 0; i < this.form.photoListBeforeAfter.length; i += 2) {
        const item1 = this.form.photoListBeforeAfter[i];
        const item2 = this.form.photoListBeforeAfter[i + 1];
        rows.push({
          idx1: i + 1,
          photo1Path: getPath(item1 ? item1.이전사진 : null),
          photoAfter1Path: getPath(item1 ? item1.이후사진 : null),
          idx2: i + 2,
          photo2Path: getPath(item2 ? item2.이전사진 : null),
          photoAfter2Path: getPath(item2 ? item2.이후사진 : null),
        });
      }
      return rows;
    },
  },
  methods: {
    // 위험도 등급 산출근거: 가능성 × 중대성 = 위험점수
    scoreSummary(item) {
      if (!item.위험점수) return "";
      return `${item.가능성}×${item.중대성}=${item.위험점수}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.print {
  .print-title {
    font-size: 32px;
    font-weight: 700;
    color: #000;
    text-align: center;
    padding: 20px 0;
  }
  .division-title {
    font-size: 24px;
    font-weight: 700;
    color: #000;
    padding: 1.25rem 0rem;
  }

  .signature-container {
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;

    .signature-image {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 80px;
      object-fit: contain;
      display: block;
    }
  }
  .photo-container {
    width: 100%;
    min-height: 120px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;

    .photo-image {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 250px;
      object-fit: contain;
      display: block;
    }
  }

  table {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
    margin-bottom: 30px;

    th,
    td {
      border: 1px solid #757575;
      text-align: center;
      font-size: 16px;
      padding: 8px;
    }
    th {
      background-color: #ececec;
      font-weight: 500;
      word-break: keep-all;
    }
    td {
      word-break: break-word;
    }
    .gray {
      background-color: #ececec;
    }
    .text-left {
      text-align: left;
      padding: 8px 12px;
    }
  }
}

@media print {
  .page-break {
    page-break-inside: auto;
    page-break-after: always;
  }
  .page-break:last-child {
    page-break-after: auto;
  }
  table {
    page-break-inside: auto;
  }
  tr {
    page-break-inside: avoid;
    page-break-after: auto;
  }
}
</style>
